import { ENV, environmentVariable, isProduction } from '@application/env';
import fetch from 'cross-fetch';

const serverUrl = environmentVariable(ENV.LOCALES_SERVER_URL);

export const logMissingKey = async (key: string) => {
  if (!isProduction()) return;
  const path = 'webhook/locales/missingKey';
  return fetch(`${serverUrl}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ key }),
  });
};
